<template>
    <div style="text-align:center;padding-top:100px;">
        <img class="pic-404__parent" src="@/assets/404.png" alt="404">
    </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>
